'use client';

import { useState } from 'react';

import { MILLION_CATCHES } from '@config/constants';
import { useClientHasRendered } from '@domain/session/useClientHasRendered';

import { DownloadAppContent } from './components/DownloadAppContent';
import { getRandomInteger } from '@lib/numbers/getRandomInteger';

export const DownloadAppVerticalCTA = () => {
  const [adCopyVariant] = useState(() => getRandomInteger(1, 2));
  const clientHasRendered = useClientHasRendered();

  // The server cannot know the client's variant, so the hydration render shows the loader too.
  if (!clientHasRendered) {
    return <DownloadAppContent isLoading />;
  }

  switch (adCopyVariant) {
    case 1:
      return (
        <DownloadAppContent
          headingText="Download the Fishbrain app"
          subHeadingText={`Discover ${MILLION_CATCHES} million fishing spots, top baits, and more`}
        />
      );
    case 2:
      return <DownloadAppContent />;
    default:
      return <DownloadAppContent isLoading />;
  }
};
